function selectVar() {

var elem = document.querySelector('.main-carousel');
var flkty = new Flickity( elem, {
  // options
        prevNextButtons: true,
        freeScroll: false,
        imagesLoaded: true,
        pageDots: false,
        wrapAround: true
});

var elem2 = document.querySelector('.carousel-nav');
var flkty2 = new Flickity( elem2, {
  // options
        asNavFor: ".main-carousel",
        imagesLoaded: true,
        contain: true,
        pageDots: false,
        prevNextButtons: false
});    
  
  document.querySelectorAll('.variant-swatch__radio').forEach(function(radioInput) {
  radioInput.addEventListener('change', function(e) {
    
    var selectedVariantUrl = e.target.parentElement.querySelector('img').src;
    selectedVariantUrl = selectedVariantUrl.replace('120x', '700x');    
    
    // Pegue todas as imagens no carrossel.
    var carouselImages = document.querySelectorAll('.main-carousel .carousel-cell img');    
    
    // Descubra qual índice da imagem corresponde à variante selecionada.
    var selectedIndex = Array.prototype.findIndex.call(carouselImages, function(img) {
      return img.src === selectedVariantUrl;
    });

    // Use Flickity 'select' para mudar para a imagem correta.
    if (selectedIndex >= 0) {
      flkty.select(selectedIndex);
    }
    
  });
});

  

//Funcionalidade para a seção de FAQ da página
$('.faq-question').click(function() {
  $(this).next('.faq-answer').slideToggle(200);

  var symbol = $(this).find('.faq-toggle-symbol');
  if (symbol.text() === '+') {
    symbol.text('-');
  } else {
    symbol.text('+');
  }
});

//Funcionalidade para rolar em área específica no mobile
// document.addEventListener("DOMContentLoaded", function() {
  
//   if (window.innerWidth < 1000) {    
//     var elemento = document.querySelector('.header');
//     if (elemento) {
//       // Se o elemento existir, faz a rolagem até ele
//       elemento.scrollIntoView();
//     }
//   }
// });
  


}
selectVar();

